/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool


// redesign this component to look more elegant and polished and accents
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy




import React, { useEffect, useState, lazy } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { MdOutlineRestaurantMenu, MdVerticalAlignTop } from "react-icons/md";

import { products_get_by_productIds } from '../../store/reducers/homeReducer';
import {
    add_to_cart,
    get_cart_products,
    move_from_cart_to_wishlist,
    messageClear,
} from '../../store/reducers/cartReducer';

import Modal2 from '../Modal2';
import useWindowSize from '../../utils/useWindowSize';
import ShopProductGridListView from '../../components/products/ShopProductGridListView';
import GetSellerConfig from '../GetSellerConfig';

import toast from 'react-hot-toast';
import config from '../../config';

const Rating = lazy(() => import('../Rating'));

const MyCustomMenu = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;
    const sellerEnvironment = config.STR_ENVIRONMENT;

    const { userInfo } = useSelector(state => state.auth);
    const { eventDetails } = useSelector(state => state.eventDetails);
    const { products, totalProduct } = useSelector(state => state.home);
    const { cart_products, successMessage, errorMessage } = useSelector(state => state.cart);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { screenWidth } = useWindowSize();

    const [modalProduct, setModalProduct] = useState(null);

    const {
        sellerPrimaryColor1,
        sellerSecondaryColor1,
        sellerShopName,
        sellerProductTerm,
        sellerProductPluralTerm,
        sellerShoppingTerm,
        sellerBoolShowSiteChat,
        sellerBoolShowSitePayments,
        sellerBoolShowSiteRating,
        sellerColorSuffixDark,
        sellerColorSuffixMedium,
        sellerColorSuffixLight,
        sellerComponentBackgroundColor,
    } = GetSellerConfig();

    const myCustomMenuProducts = [...products].sort((a, b) => a.name.localeCompare(b.name));

    // ─── Dynamic color tokens ─────────────────────────────────────────────────
    const colorPrimaryDark   = sellerPrimaryColor1 + sellerColorSuffixDark;
    const colorPrimaryMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
    const colorPrimaryLight  = sellerPrimaryColor1 + sellerColorSuffixLight;

    // ─── Inline style objects (only for dynamic seller colors) ────────────────
    
    const panelStyle = {
        borderColor: colorPrimaryDark,
        backgroundColor: colorPrimaryLight,
        borderTop: `6px solid ${colorPrimaryDark}`,
    };

    const panelLabelStyle = {
        color: sellerPrimaryColor1,
        borderBottomColor: colorPrimaryLight,
    };

    const panelValueStyle = {
        color: colorPrimaryDark,
    };

    const instructionsLinkStyle = {
        color: colorPrimaryMedium,
    };

    const instructionsBoxStyle = {
        borderColor: colorPrimaryDark,
        backgroundColor: colorPrimaryLight,
    };

    const instructionsTitleStyle = {
        color: sellerPrimaryColor1,
        borderBottomColor: colorPrimaryLight,
    };

    const scrollTopBtnStyle = {
        backgroundColor: sellerPrimaryColor1,
        color: sellerSecondaryColor1,
    };

    // ─── Effects ──────────────────────────────────────────────────────────────
    useEffect(() => {
        if (!eventDetails?.customMenuProducts) return;
        const parsed = JSON.parse(eventDetails.customMenuProducts);
        const productIds = parsed.map(p => p._id).join(',');
        dispatch(products_get_by_productIds(productIds));
    }, [dispatch, eventDetails?.customMenuProducts]);

    useEffect(() => {
        if (userInfo?.id) dispatch(get_cart_products(userInfo.id));
    }, [dispatch, userInfo?.id]);

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
            if (userInfo?.id) dispatch(get_cart_products(userInfo.id));
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
    }, [dispatch, successMessage, errorMessage, userInfo?.id]);

    // ─── Handlers ─────────────────────────────────────────────────────────────
    const openModal = (product) => setModalProduct(product);
    const closeModal = () => setModalProduct(null);

    const redirect_chat_page = (chatTopic) => {
        navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
    };

    const handleAddAllToCart = () => {
        if (!userInfo) { navigate('/login'); return; }
        if (cart_products.length > 0) {
            cart_products[0].products.forEach(p => dispatch(move_from_cart_to_wishlist(p._id)));
        }
        products.forEach(p => {
            dispatch(add_to_cart({ userId: userInfo.id, quantity: 1, productId: p._id, portionSize: '' }));
        });
    };

    const handleProductChange = (e) => {
        const targetId = e.target.value.replaceAll(' ', '_');
        document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const scrollToCustomMenuInstructions = () => {
        document.getElementById('custom_menu_instructions')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    // ─── Render ───────────────────────────────────────────────────────────────
    return (
        <div className="bg-white rounded-2xl">
            <div
                id="top"
                className="rounded-2xl border p-4"
                style={{ 
                    backgroundColor: colorPrimaryLight, 
                    borderColor: colorPrimaryDark 
                }}>
                <div className="flex items-center gap-2 mb-1 pb-0"
                    style={{ borderBottom: `0px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}` }}>
                    <div>
                        <MdOutlineRestaurantMenu size={52} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                    </div>
                    <div>
                        <div
                            className="text-2xl font-bold tracking-tight leading-none"
                            style={{ color: sellerPrimaryColor1 }}>
                            My Custom Menu
                        </div>
                        <div className="text-md mt-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                            Curated and created just for you !!
                        </div>
                    </div>
                </div>

                {/* ── Header: 3-panel grid ───────────────────────────────────────── */}
                <div className="grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4">

                    {/* Panel 1 — Title & jump-to */}
                    <div
                        className="flex flex-col items-center justify-center gap-3 rounded-xl border px-4 py-1"
                        style={panelStyle}>
                        <div className="flex flex-col items-center gap-0.5">
                            <span className="text-lg font-semibold" style={panelValueStyle}>
                                My Custom Menu
                            </span>
                            <span className="text-xs" style={panelValueStyle}>
                                {totalProduct} {sellerProductPluralTerm}
                            </span>
                        </div>

                        {/* Jump-to dropdown */}
                        <select
                            className="w-full text-xs px-2 py-1.5 rounded-lg border cursor-pointer outline-none 
                            focus:ring-2 focus:ring-offset-1 transition"
                            style={{
                                borderColor: colorPrimaryDark,
                                color: sellerPrimaryColor1,
                                backgroundColor: sellerSecondaryColor1,
                            }}
                            onChange={handleProductChange}
                            value="">
                            <option value="">↓ Go To {sellerProductTerm}</option>
                            {myCustomMenuProducts.map((p, i) => (
                                <option key={i} value={p?.name}>{p?.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* Panel 2 — Suggested by */}
                    <div
                        className="flex flex-col items-center justify-center gap-2 rounded-xl border px-4 py-1"
                        style={panelStyle}>
                        <span
                            className="text-[11px] uppercase tracking-widest font-semibold pb-1 mb-1 border-b w-full text-center"
                            style={panelLabelStyle}>
                            Suggested By
                        </span>
                        <span className="text-lg font-semibold text-center" style={panelValueStyle}>
                            {sellerShopName}
                        </span>
                        {eventDetails?.customMenuInstructions && (
                            <button
                                onClick={scrollToCustomMenuInstructions}
                                className="text-xs underline underline-offset-2 opacity-80 hover:opacity-100 transition"
                                style={instructionsLinkStyle}>
                                View Menu Instructions ↓
                            </button>
                        )}
                    </div>

                    {/* Panel 3 — Add all to cart */}
                    <div
                        className="flex flex-col items-center justify-center gap-3 rounded-xl border px-4 py-1"
                        style={panelStyle}>
                        <span
                            className="text-[11px] uppercase tracking-widest font-semibold pb-0 mb-0 border-b w-full text-center"
                            style={panelLabelStyle}>
                            Order Action
                        </span>
                        <button
                            onClick={handleAddAllToCart}
                            className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold 
                            text-white transition-all duration-150"
                            style={{
                                backgroundColor: sellerPrimaryColor1,
                                borderColor: sellerPrimaryColor1
                            }}>
                            <MdOutlineRestaurantMenu size={20} />
                            Add All To My Menu
                        </button>
                        <p className="text-[11px] text-center leading-relaxed opacity-60" style={panelValueStyle}>
                            Existing {sellerProductPluralTerm} in your menu<br />will move to your Wishlist
                        </p>
                    </div>
                </div>

                {/* ── Decorative divider ────────────────────────────────────────── */}
                <div className="my-4 h-px w-full" 
                    style={{
                        background: `linear-gradient(to right, transparent, ${colorPrimaryDark}, transparent)`,
                    }} />

                {/* ── Product grid ──────────────────────────────────────────────── */}
                {products?.length > 0 && (
                    <ShopProductGridListView
                        products={myCustomMenuProducts}
                        styles="grid"
                        showAllProductsButton={false}
                        showScrollToTopButton={true}
                        columnCount={3}
                    />
                )}

                {/* ── Custom menu instructions ──────────────────────────────────── */}
                {eventDetails?.customMenuInstructions && (
                    <div
                        id="custom_menu_instructions"
                        className="mt-6 rounded-xl border p-5"
                        style={instructionsBoxStyle}>
                        {/* Instructions header */}
                        <div
                            className="flex items-center justify-between pb-3 mb-3 border-b"
                            style={instructionsTitleStyle}>
                            <span className="text-sm font-semibold tracking-wide uppercase">
                                Menu Instructions
                            </span>
                            <button
                                onClick={scrollToTop}
                                className="flex items-center gap-1 px-3 py-1 rounded-md text-xs font-semibold hover:opacity-90 transition"
                                style={scrollTopBtnStyle}>
                                <MdVerticalAlignTop size={13} />
                                Top
                            </button>
                        </div>

                        {/* Instructions body */}
                        <p className="text-sm leading-relaxed opacity-80" style={panelValueStyle}>
                            {eventDetails.customMenuInstructions}
                        </p>
                    </div>
                )}

                <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
            </div>
        </div>
    );
};

export default MyCustomMenu;







//refactored before redeisgn
// import React, { useEffect, useState, lazy } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaEye } from "react-icons/fa";
// import { MdOutlineRestaurantMenu, MdVerticalAlignTop } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

// import { products_get_by_productIds } from '../../store/reducers/homeReducer';
// import {
//     add_to_cart,
//     get_cart_products,
//     move_from_cart_to_wishlist,
//     messageClear,
// } from '../../store/reducers/cartReducer';

// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import ShopProductGridListView from '../../components/products/ShopProductGridListView';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import config from '../../config';

// const Rating = lazy(() => import('../Rating'));

// const MyCustomMenu = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerEnvironment = config.STR_ENVIRONMENT;

//     const { userInfo } = useSelector(state => state.auth);
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     const { products, totalProduct } = useSelector(state => state.home);
//     const {
//         cart_products,
//         successMessage,
//         errorMessage,
//     } = useSelector(state => state.cart);

//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { screenWidth } = useWindowSize();

//     const [modalProduct, setModalProduct] = useState(null);

//     const {
//         sellerPrimaryColor1,
//         sellerSecondaryColor1,
//         sellerShopName,
//         sellerProductTerm,
//         sellerProductPluralTerm,
//         sellerShoppingTerm,
//         sellerBoolShowSiteChat,
//         sellerBoolShowSitePayments,
//         sellerBoolShowSiteRating,
//     } = GetSellerConfig();

//     const myCustomMenuProducts = [...products].sort((a, b) => a.name.localeCompare(b.name));

//     const baseStyle = {
//         backgroundColor: sellerSecondaryColor1,
//         color: sellerPrimaryColor1,
//         borderColor: sellerPrimaryColor1,
//     };

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1,
//     };

//     const iconBtnStyle = {
//         backgroundColor: 'white',
//         color: sellerPrimaryColor1,
//         borderColor: sellerPrimaryColor1,
//     };

//     // Load products by IDs from the custom menu event
//     useEffect(() => {
//         if (!eventDetails?.customMenuProducts) return;
//         const parsed = JSON.parse(eventDetails.customMenuProducts);
//         const productIds = parsed.map(p => p._id).join(',');
//         dispatch(products_get_by_productIds(productIds));
//     }, [dispatch, eventDetails?.customMenuProducts]);

//     // Load cart on mount
//     useEffect(() => {
//         if (userInfo?.id) {
//             dispatch(get_cart_products(userInfo.id));
//         }
//     }, [dispatch, userInfo?.id]);

//     // Toast feedback
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//             if (userInfo?.id) dispatch(get_cart_products(userInfo.id));
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [dispatch, successMessage, errorMessage, userInfo?.id]);

//     const openModal = (product) => setModalProduct(product);
//     const closeModal = () => setModalProduct(null);

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`);
//         } else {
//             navigate('/login');
//         }
//     };

//     const handleAddAllToCart = () => {
//         if (!userInfo) {
//             navigate('/login');
//             return;
//         }
//         // Move existing cart items to wishlist
//         if (cart_products.length > 0) {
//             cart_products[0].products.forEach(p => {
//                 dispatch(move_from_cart_to_wishlist(p._id));
//             });
//         }
//         // Add all custom menu products to cart
//         products.forEach(p => {
//             dispatch(add_to_cart({
//                 userId: userInfo.id,
//                 quantity: 1,
//                 productId: p._id,
//                 portionSize: '',
//             }));
//         });
//     };

//     const handleProductChange = (e) => {
//         const targetId = e.target.value.replaceAll(' ', '_');
//         const element = document.getElementById(targetId);
//         if (element) {
//             element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//     };

//     const scrollToCustomMenuInstructions = () => {
//         document.getElementById('custom_menu_instructions')
//             ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     };

//     const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

//     return (
//         <div
//             id="top"
//             className="border p-4 rounded-md"
//             style={baseStyle}
//         >
//             {/* Header row */}
//             <div className="w-full text-xl grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1">
//                 {/* Title + Jump-to dropdown */}
//                 <div className="font-semibold w-full text-center">
//                     <div>My Custom Menu</div>
//                     <div>({totalProduct} {sellerProductPluralTerm})</div>
//                     <div className="mt-1 mb-1 font-normal text-sm">
//                         <select
//                             className="px-1 py-0.5 w-[200px] text-sm border rounded-md font-normal cursor-pointer"
//                             onChange={handleProductChange}
//                             value=""
//                             style={baseStyle}
//                         >
//                             <option value="">Go To {sellerProductTerm}</option>
//                             {myCustomMenuProducts.map((p, i) => (
//                                 <option key={i} value={p?.name}>{p?.name}</option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>

//                 {/* Suggested by */}
//                 <div className="w-full text-center">
//                     <div className="font-semibold">Suggested By</div>
//                     <div className="font-semibold">{sellerShopName}</div>
//                     {eventDetails?.customMenuInstructions && (
//                         <div className="flex flex-col items-center justify-center mt-0.5">
//                             <button
//                                 onClick={scrollToCustomMenuInstructions}
//                                 className="hover:underline text-[16px] font-normal"
//                                 style={{ color: sellerPrimaryColor1 }}
//                             >
//                                 Custom Menu Instructions
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 {/* Add all to cart */}
//                 <div className="w-full flex flex-col items-center justify-center text-center">
//                     <button
//                         onClick={handleAddAllToCart}
//                         className="py-0.5 px-3 flex items-center text-white rounded-md text-[16px]"
//                         style={{ backgroundColor: sellerPrimaryColor1, color: sellerSecondaryColor1 }}
//                     >
//                         <MdOutlineRestaurantMenu className="mr-1 text-[18px]" />
//                         Add To My Menu
//                     </button>
//                     <div className="mt-2 text-sm">
//                         <div>Existing {sellerProductPluralTerm} In My Menu</div>
//                         <div>Will Get Moved To My Wishlist</div>
//                     </div>
//                 </div>
//             </div>

//             {/* Product grid */}
//             {products?.length > 0 && (
//                 <ShopProductGridListView
//                     products={myCustomMenuProducts}
//                     styles="grid"
//                     showAllProductsButton={false}
//                     showScrollToTopButton={true}
//                     columnCount={3}
//                 />
//             )}

//             {/* Custom menu instructions */}
//             {eventDetails?.customMenuInstructions && (
//                 <div
//                     id="custom_menu_instructions"
//                     className="w-full border items-center justify-center mt-2 p-2"
//                     style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1 }}
//                 >
//                     <div className="flex justify-center items-center gap-2">
//                         <span className="text-lg font-bold">Custom Menu Instructions</span>
//                         <button
//                             onClick={scrollToTop}
//                             className="flex items-center pl-1 pr-1 rounded-md text-white text-sm font-semibold"
//                             style={{ backgroundColor: sellerPrimaryColor1 }}
//                         >
//                             <MdVerticalAlignTop size={15} className="mt-0.5" /> Top
//                         </button>
//                     </div>
//                     <div className="mt-1">{eventDetails.customMenuInstructions}</div>
//                 </div>
//             )}

//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//         </div>
//     );
// };

// export default MyCustomMenu;




//my original code
// import React, { useEffect, useState, lazy }  from 'react';
// import {  useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaEye, FaRegTrashAlt} from "react-icons/fa";
// import { RiShoppingCartLine } from "react-icons/ri";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { TbArrowBigRightLinesFilled } from "react-icons/tb";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { MdVerticalAlignTop } from "react-icons/md";

// import {products_get_by_productIds} from '../../store/reducers/homeReducer';
// import { add_to_cart, get_cart_products, move_from_cart_to_wishlist, messageClear, successMessage, errorMessage } 
//     from '../../store/reducers/cartReducer';
// //get_wishlist_products, remove_from_wishlist, move_from_wishlist_to_cart, remove_from_cart_to_wishlist,

// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import SkeletonWithImage from '../SkeletonWithImage';
// import ShopProductGridListView from '../../components/products/ShopProductGridListView';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';

// import config from '../../config';

// const Rating = lazy(()=> import('../Rating')) 

// const MyCustomMenu = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerEnvironment = config.STR_ENVIRONMENT

//     const { userInfo } = useSelector(state => state.auth)
//     //const { depositProduct } = useSelector(state => state.home)
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     //const { seller } = useSelector(state => state.seller)
//     const {allSiteProducts, products, totalProduct } = useSelector(state => state.home)
//     const { cart_products, cart_product_count, buy_product_item, wishlist_count,
//         shipping_fee, outofstock_products, errorMessage, successMessage } = useSelector(state => state.cart) //outOfStockProduct price,
    
//     const myCustomMenuProducts = [...products].sort((a, b) => a.name.localeCompare(b.name));
    
//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
//         sellerProductTerm, sellerProductPluralTerm, sellerShoppingTerm,
//         sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
//         sellerBoolShowSitePayments, sellerBoolShowSiteRating
//     } = GetSellerConfig();

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };
//     const { screenWidth, screenHeight } = useWindowSize();
    
//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//         setModalProduct(product);
//     };
//     const closeModal = () => {
//         setModalProduct(null);
//     };

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }
    
//     const dispatch = useDispatch()
//     const navigate = useNavigate()
    
//     //const [customMenuItems, setCustomMenuItems] = useState([])
//     //eventDetails?.customMenuProducts
    
//     useEffect(() => {
//         let productIds = ''
//         if (eventDetails?.customMenuProducts) {
//             //setCustomMenuItems(JSON.parse(eventDetails?.customMenuProducts) )//|| eventDetails?.customMenuProducts
//             //console.log('eventDetails?.customMenuProducts', eventDetails?.customMenuProducts)
//             JSON.parse(eventDetails?.customMenuProducts).map((p, i) => (
//                 productIds += `${p._id},`
//             ))
//             productIds = productIds.substring(0, productIds.length - 1);
//             //console.log('productIds', productIds)
//             dispatch(products_get_by_productIds(productIds))
//         }
//     }, [dispatch, eventDetails?.customMenuProducts])
    
//     useEffect(() => {
//         dispatch(get_cart_products(userInfo.id))
//     },[])
    
//     const move_from_cart_to_wishlist_local = (id) => {
//         if (userInfo) {
//             //loop
//             if (cart_products.length > 0) {
//                 cart_products[0].products.map((p, i) => {
//                     //console.log('p._id ', p._id)
//                     dispatch(move_from_cart_to_wishlist(p._id))
//                 })
//             }

//             products.map((p, i) => {
//                 //console.log('p._id ', p._id, p.name)
//                 dispatch(add_to_cart({
//                     userId: userInfo.id,
//                     quantity: 1,
//                     productId : p._id, // product._id,
//                     portionSize: '' //portionSize
//                 }))  
//             })
//         } else {
//             navigate('/login')
//         }
//     }

//     const handleProductChange = (e) => {
//         //console.log('e.target.value', e.target.value)
//         const targetId = e.target.value.replaceAll(' ', '_');
//         const element = document.getElementById(targetId);
//         if (element) {
//             // Smoothly scrolls to the element with the matching ID
//             element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//     }
//     const scrollToCustomMenuInstructions = () => {
//         //window.scrollTo({ top: 0, behavior: 'smooth' });
//         const element = document.getElementById('custom_menu_instructions');
//         if (element) {
//             // Smoothly scrolls to the element with the matching ID
//             element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//     }
//     const scrollToTop = () => {
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//             dispatch(get_cart_products(userInfo.id))
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div id='top' className='border p-4 rounded-md'
//             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//             {
//                 //text-2xl font-bold flex flex-col gap-1 mb-2 
//                 //w-full text-xl grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-2 mt-3
//                 //flex flex-col mb-3 md:flex-row gap-4 w-full
//             }
//             <div className='w-full text-xl grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1'>
//                 <div className='font-semibold w-full text-center'>
//                     <div className='border-none border-black' >My Custom Menu</div>
//                     <div className='border-none border-black'>({totalProduct} {sellerProductPluralTerm})</div>
//                     <div className='mt-1 mb-1 font-normal text-sm border-none border-black'>
//                         <select className='px-1 py-0.5 w-[200px] text-sm border rounded-md font-normal cursor-pointer' 
//                             onChange={(e) => handleProductChange(e)} name='' id='' value={''}
//                             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             <option value="">Go To {sellerProductTerm}</option>
//                             {
//                                 products.slice(0, products.length).sort((a, b) => a.name.localeCompare(b.name)).map((p, i) => (
//                                     <option key={i} value={p?.name}>{p?.name}</option>
//                                 ))
//                             }
//                         </select>
//                     </div>
//                 </div> 
//                 <div className='border-none border-black w-full text-center'>
//                     <div className='font-semibold '>Suggested By</div>
//                     <div className='border-none border-red-600  font-semibold '>
//                         {sellerShopName}
//                     </div>
//                     <div className='border-none border-red-600 flex flex-col items-center justify-center justify-items-center'>
//                         {eventDetails?.customMenuInstructions ? (
//                             <span className='mt-0.5'>
//                                 <button onClick={scrollToCustomMenuInstructions} 
//                                     className={`border-none border-green-600 hover:underline flex flex-col text-[16px] font-normal`}
//                                     style={{color:sellerPrimaryColor1}}>
//                                     Custom Menu Instructions
//                                 </button>
//                             </span>
//                         ) : (
//                             <span className=''></span>
//                         )}
//                     </div>
//                 </div>
//                 <div className='w-full'>
//                     <div className='w-full items-center justify-content-center flex flex-col justify-center text-center'>
//                         <button onClick={move_from_cart_to_wishlist_local} 
//                             className='py-0.5 px-3 flex text-white rounded-md text-[16px]' 
//                             style={{backgroundColor:sellerPrimaryColor1, color:sellerSecondaryColor1, borderColor:sellerSecondaryColor1}}>
//                             <MdOutlineRestaurantMenu className='mr-1 mt-1 text-[18px]' /> Add To My Menu
//                         </button>
//                     </div>
//                     <div className='mt-2 w-full items-center justify-content-center flex flex-col justify-center text-center text-sm'>
//                         <div>Existing {sellerProductPluralTerm} In My Menu</div>
//                         <div>Will Get Moved To My Wishlist</div>
//                     </div>
//                 </div>
//             </div>
//             {
//                 // className='border-2 group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                 //.sort((a, b) => a.name.localeCompare(b.name))
//             }
//             <div>
//                 {products && products.length > 0 && (
//                     <ShopProductGridListView products={myCustomMenuProducts}
//                         styles="grid" showAllProductsButton={false} showScrollToTopButton={true} columnCount={3} />
//                 )}
//             </div>
//             {/* grid   */}
//             <div className='hidden w-full grid-cols-3 md-lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-2 mt-3'>
//                 {
//                     products.slice(0, products.length).sort((a, b) => a.name.localeCompare(b.name)).map((p, i) => (
//                     <div key={i} className='border-2 group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                         style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
                        
//                         <div className='relative overflow-hidden' id={p?.name.replaceAll(' ', '_')}>
//                             <div className="relative text-center">
//                                 <SkeletonWithImage src={p?.images[0]} alt={p?.name}
//                                     className="w-full h-[200px] object-cover" />
//                                 {p.byThePan !== 'NoPan' && (
//                                     <div className="m-1 border w-[97%]  h-[30px] absolute top-0 left-0 text-center"
//                                         style={{backgroundColor: sellerSecondaryColor1,color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1}}>
//                                         {p?.byThePan}
//                                     </div>
//                                 )}
//                             </div>
                        
//                             <div className="hidden relative text-center">
//                                 <img className={`sm:w-full w-full h-[200px]`} src={p.images[0]}  alt="" />  
//                                 <div className={` ${p.byThePan === 'NoPan' ? 'hidden' : ''}  
//                                     m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center`}
//                                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     {p.byThePan}
//                                 </div>
//                             </div>

//                             {/* hover:bg-[#059473] hover:text-white hover:rotate-[720deg]  */}
//                             {
//                             //<ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                             }
//                             <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center 
//                                 gap-2 absolute w-full group-hover:bottom-3'>
//                                 {
//                                     //onClick={() => move_from_wishlist_to_cart_local(p._id)}
//                                     //flex
//                                 }
//                                 <span  
//                                     className='hidden w-[38px] h-[38px] cursor-pointer border bg-white justify-center items-center rounded-full transition-all'
//                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className="icon-container">
//                                         <span className='icon flex justify-center items-center'>
//                                             &nbsp;<TbArrowBigRightLinesFilled /> <MdOutlineRestaurantMenu />&nbsp;
//                                         </span>
//                                         <div className='tooltip' style={tooltipHoverStyle}>Move To<br />{sellerShoppingTerm}</div>
//                                     </div>
//                                 </span>
//                                 {
//                                     //onClick={() => dispatch(remove_from_wishlist(p._id))}
//                                     //flex
//                                 }
//                                 <li  
//                                     className='hidden w-[38px] h-[38px] cursor-pointer border bg-white justify-center items-center rounded-full transition-all'
//                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className="icon-container">
//                                         <span className='icon flex justify-center items-center'>
//                                             &nbsp;<FaRegTrashAlt />&nbsp;
//                                         </span>
//                                         <div className='tooltipSmall' style={tooltipHoverStyle}>Remove<br />From<br />Wishlist</div>
//                                     </div>
//                                 </li>
//                                 <li className='hidden'>
//                                     {/* onClick={() => openModal(p)} */}
//                                     {/*  to={`/product/details/${p.productId}` */}
//                                     {/*  get product obeject fromm productid */ }
//                                     <Link to={`/product/details/${p.productId}`}
//                                         className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<FaEye />&nbsp;
//                                             </span>
//                                             <div className="tooltip" style={tooltipHoverStyle}>More<br />Details</div>
//                                         </div>
//                                     </Link>
//                                 </li>
//                                 <Link onClick={() => openModal(p)}
//                                     className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className="icon-container">
//                                         <span className='icon flex justify-center items-center'>
//                                             &nbsp;<FaEye />&nbsp;
//                                         </span>
//                                         <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                     </div>
//                                 </Link>
//                                 {/*onClick={redirect_chat_page}*/}
//                                 <span onClick={() => redirect_chat_page(p.name)} 
//                                     className={` ${sellerBoolShowSiteChat ? '' : 'hidden'}  
//                                     w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all`}
//                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className="icon-container">
//                                         <span className='icon flex justify-center items-center'>
//                                             &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                         </span>
//                                         <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                     </div>
//                                 </span>
//                             </ul>
//                         </div>
//                         <div className='py-3 px-2'>
//                             <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                 <span className='font-bold'>{p.name}</span>
//                                 <button onClick={scrollToTop} 
//                                     className={`flex mt-0 pr-1 pl-1 rounded-md text-white text-[13px] font-semibold`}
//                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                     <MdVerticalAlignTop size={14} className='font-bold mt-0.5' /> Top
//                                 </button>
//                             </div>
//                             {
//                             //justify-between flex flex-col
//                             }
//                             <div className='sm:hidden items-center text-md gap-0 pb-1 border-none border-black relative'>
//                                 <span className='p-[2px] font-semibold absolute right-0 top-0 border-none border-green-600 '>
//                                     <button onClick={scrollToTop} 
//                                         className={`flex mt-0 pr-1 pl-1 rounded-md text-white text-[13px] font-semibold`}
//                                         style={{backgroundColor:sellerPrimaryColor1}}>
//                                         <MdVerticalAlignTop size={14} className='font-bold mt-0.5' /> Top
//                                     </button>
//                                 </span>
//                                 <div className='border-none border-red-600 w-full'>
//                                     <span className='font-bold border-none border-red-600'>{p.name?.substring(0, parseInt(screenWidth / 66))}</span>
//                                     <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 66))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                 </div>
//                             </div>
//                             {
//                                 // ${(p.name?.length >= 20) ? 'inline-block' : 'inline-block'}
//                                 // w-[320px]
//                                 // <div className='sm:hidden'>
//                                 //     <span className='font-bold'>{p.name?.substring(0, parseInt(screenWidth / 66))}</span>
//                                 //     <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 66))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                 // </div>
//                             }
//                             <div className='flex justify-start items-center gap-3'>
//                                 <span className={`${sellerBoolShowSitePayments ? '' : 'hidden'} text-md font-semibold`}>
//                                     {currencyFormat.format(p.price)}
//                                 </span>
//                                 <div className={`${sellerBoolShowSiteRating ? 'flex' : 'hidden'} `}>
//                                     <Rating ratings={p.rating} />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className={`${p.portionSizes === '' ? '' : ''} 
//                             border px-1 py-1 mb-1 w-full text-[14px] font-semibold`}
//                             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                             <span className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                 {p.description?.substring(0, parseInt(screenWidth / 10))} ...
//                             </span>
//                             <span className='sm:hidden'>
//                                 {p.description?.substring(0, parseInt(screenWidth / 50))} ...
//                             </span>
//                         </div>
//                         <div className='hidden font-semibold'>{p.name}</div>
//                         <div className='hidden text-sm'>{p.description}</div>
//                     </div>
//                     ))
//                 }
//             </div>
//             <div id="custom_menu_instructions" 
//                 className={` ${eventDetails?.customMenuInstructions === '' ? 'hidden' : ''}  
//                 w-full border items-center justify-items-center justify-center mt-2`}
//                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1}}>
//                 <div className='flex justify-center'>
//                     <span className='text-lg font-bold'>Custom Menu Instructions</span>
//                     <span className='text-lg font-bold'>
//                         <button onClick={scrollToTop} 
//                             className={`flex mt-1 ml-2 pl-1 pr-1 rounded-md text-white text-sm font-semibold`}
//                             style={{backgroundColor:sellerPrimaryColor1}}>
//                             <MdVerticalAlignTop size={15} className='font-bold mt-0.5' /> Top
//                         </button>
//                     </span>
//                 </div>
//                 <div>
//                     {eventDetails?.customMenuInstructions}
//                 </div>
//             </div>
//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />   
//         </div>
//     );
// };

// export default MyCustomMenu;







